"use client";

import * as React from "react";

function readAnnouncementHeight(): number {
  if (typeof window === "undefined") return 0;
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue("--announcement-h")
    .trim();
  const parsed = Number.parseFloat(raw);
  return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * Keeps `--nav-height`, `--nav-offset`, and `--chapter-position` in sync with
 * the fixed announcement bar and header. Falls back to CSS defaults until both
 * mount.
 */
export function NavOffsetSync() {
  React.useEffect(() => {
    const sync = () => {
      const header = document.querySelector("header");
      if (!header) return;

      const navHeight = header.getBoundingClientRect().height;
      const announcementHeight = readAnnouncementHeight();
      const navOffset = announcementHeight + navHeight;

      document.documentElement.style.setProperty(
        "--nav-height",
        `${Math.round(navHeight)}px`
      );
      document.documentElement.style.setProperty(
        "--nav-offset",
        `${Math.round(navOffset)}px`
      );
      document.documentElement.style.setProperty(
        "--chapter-position",
        `${Math.round(navOffset)}px`
      );
    };

    sync();

    const header = document.querySelector("header");
    const announcement = document.getElementById("home-announcement-bar");

    const headerObserver = header && new ResizeObserver(sync);
    headerObserver?.observe(header!);

    const announcementObserver = announcement && new ResizeObserver(sync);
    announcementObserver?.observe(announcement!);

    window.addEventListener("resize", sync);
    window.addEventListener("announcement-h-change", sync);
    header?.addEventListener("transitionend", sync);

    return () => {
      headerObserver?.disconnect();
      announcementObserver?.disconnect();
      window.removeEventListener("resize", sync);
      window.removeEventListener("announcement-h-change", sync);
      header?.removeEventListener("transitionend", sync);
    };
  }, []);

  return null;
}
